var map = {
	"./WhatsApp Image 2025-01-28 at 4.38.17 PM (1).jpeg": 33328,
	"./WhatsApp Image 2025-01-28 at 4.38.17 PM (2).jpeg": 78095,
	"./WhatsApp Image 2025-01-28 at 4.38.17 PM.jpeg": 24214
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25869;